import { render } from "./withdrawal-list.vue?vue&type=template&id=9a5ccd7a"
import script from "./withdrawal-list.vue?vue&type=script&lang=js"
export * from "./withdrawal-list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__